import { render } from "./HeroAuthGrid.vue?vue&type=template&id=957901bc&scoped=true"
import script from "./HeroAuthGrid.vue?vue&type=script&lang=js"
export * from "./HeroAuthGrid.vue?vue&type=script&lang=js"

import "./HeroAuthGrid.vue?vue&type=style&index=0&id=957901bc&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957901bc"]])

export default __exports__